/**
 * Messages sent to the nested checkout iframe from Sole Panel.
 */
export enum CheckoutPostMessageAction {
    CLEAR_CART = 'clearCart',
    ENABLE_PLACE_ORDER = 'enablePlaceOrderButton',
    SET_CART = 'setCart'
}

export interface CheckoutPostMessage {
    /**
     * The action to take.
     *
     * clearCart: clear the cart cookie
     * setCart: sets the cart to the provided value.
     * enablePlaceOrderButton: Signal to enable the place order button.
     */
    action: CheckoutPostMessageAction;
    data?: {
        // Interaction Id created by sole panel, lets us know that the service agent is able to place an order
        cookie?: string;
        interactionId?: string; // DCSG-CART cookie
    };
}

// clearCart (totally clear cart cookie session)
// setCart (clearCart on checkout UI side prior to setting cart cookie)
// enablePlaceOrderButton (prevent order from being placed until enable place order event occurs)